import { civilDate, nextDay } from "./dayMath"

export interface DayCell {
  date: string
  isToday: boolean
  isCurrent: boolean
}

export function buildDateStrip(
  now: Date,
  tz: string,
  rangeDays: number,
  currentDate: string,
): DayCell[] {
  const today = civilDate(now, tz)
  const cells: DayCell[] = []
  let d = today
  for (let i = 0; i <= rangeDays; i++) {
    cells.push({
      date: d,
      isToday: d === today,
      isCurrent: d === currentDate,
    })
    if (i < rangeDays) {
      d = nextDay(d, tz)
    }
  }
  return cells
}

export function clampToRange(
  date: string,
  tz: string,
  now: Date = new Date(),
  rangeDays: number = 30,
): string {
  const today = civilDate(now, tz)
  if (date < today) return today

  let end = today
  for (let i = 0; i < rangeDays; i++) {
    end = nextDay(end, tz)
  }
  if (date > end) return end

  return date
}
